module.exports = __webpack_public_path__ + "img/STERiJECT_04.0038b8ca.png";